"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationJumpItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PaginationJumpItemMixin = require("../../mixins/components/PaginationJumpItemMixin");
/**
 * Used by the `Pagination` component to house the "previous" and "next" buttons based on
 * `PaginationButton`.
 *
 * @since 7.42.0
 */
var PaginationJumpItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "PaginationJumpItem",
  componentId: "c11n-8-107-0__sc-h97wcm-0"
})(["", ""], _PaginationJumpItemMixin.PaginationJumpItemMixin);
exports.PaginationJumpItem = PaginationJumpItem;
PaginationJumpItem.displayName = 'PaginationJumpItem';

/** @component */